import axios from 'axios'

const changeCodeStatus = async (id, packageId) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/changeStatus/${packageId}?codes=${id}`,
      {},
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )

    return response
  } catch (error) {
    throw error
  }
}

export default changeCodeStatus
